module.exports = __webpack_public_path__ + "img/mz.bc33186e.svg";